export const GET_WEB_ORDER_PENDING = 'GET_WEB_ORDER_PENDING'
export const GET_WEB_ORDER_SUCCESSFUL = 'GET_WEB_ORDER_SUCCESSFUL'
export const GET_WEB_ORDER_ERROR = 'GET_WEB_ORDER_ERROR'
